import style from './site-header.scss';
import staticSizes from 'DesignSystem/layout/static-sizes';

const script = () => {
  const cssClass: string = 'SiteHeader';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;
    const isHomeBanner = document.querySelector('.HomeBanner') !== null;
    const body = document.querySelector('body');

    // Initial state
    let scrollPos = 0;
    let isHeaderFullBannerTop = true;
    let idTimeOut: ReturnType<typeof setTimeout>;
    // const deltaScroll = 0;  // increase the value to allow slow scroll top to keep the the SiteHeader visible
    // adding scroll event
    window.addEventListener('scroll', ()=>{
      // detects new state and compares it with the new one
      const scrollTop = (document.body.getBoundingClientRect()).top;
      const scrollingBottom = scrollTop < scrollPos;
      // do nothing at load
      // saves the new position for iteration.
      scrollPos = (document.body.getBoundingClientRect()).top;

      if (document.documentElement.scrollTop === 0) {
        body.style.paddingTop = '';
        elt.classList.add('isOnTop');
      }
      else {
        body.setAttribute('style', 'padding-top: 0 !important');
        elt.classList.remove('isOnTop');
      }

      if (scrollingBottom) {
        elt.classList.add('isScrollingDown');
      } else {
        elt.classList.remove('isScrollingDown');
      }

      if (isHomeBanner === true) {
        if(isHeaderFullBannerTop && scrollingBottom && scrollTop < -staticSizes.params['site-header'].height.mobile) {
          isHeaderFullBannerTop = false;
          clearInterval(idTimeOut);
          idTimeOut = setInterval(()=> {
            elt.classList.remove('isHeaderFullBannerTop');
          }, 1000);
        }
        if(!isHeaderFullBannerTop && !scrollingBottom && scrollTop > -staticSizes.params['site-header'].height.mobile/2){
          clearInterval(idTimeOut);
          isHeaderFullBannerTop = true;
          elt.classList.add('isHeaderFullBannerTop');
        }
      }
    });
    if (isHomeBanner === true) {
      elt.classList.add('isHeaderFullBannerTop');
    }
    elt.classList.add('isOnTop');
  }
};

export {
  style,
  script,
};
